import { useEffect, useState } from 'react';
import Select from 'react-select';
import { IoCloseSharp } from 'react-icons/io5';

import {
  ItemRow,
  ItemInput,
  SelectWrapper,
  RemoveIcon
} from './add-order-item.styles';

const AddOrderItem = ({ inventories, onRemove, onChange }) => {
  const [inventoryId, setInventoryId] = useState('');
  const [quantity, setQuantity] = useState(1);
  const [unitPrice, setUnitPrice] = useState(0);

  const selectedInventory = inventories.find(
    (inv) => inv.id.toString() === inventoryId
  );

  useEffect(() => {
    if (selectedInventory?.price != null) {
      setUnitPrice(selectedInventory.price);
    }
  }, [inventoryId]);

  useEffect(() => {
    if (inventoryId && selectedInventory && onChange) {
      onChange({
        inventoryId: parseInt(inventoryId),
        productId: selectedInventory.productId,
        quantity,
        unitPrice,
        isNew: true
      });
    }
  }, [inventoryId, quantity, unitPrice]);

  const inventoryOptions = [
    {
      label: '-- Select Inventory --',
      value: '',
      isDisabled: true
    },
    ...inventories.map((inv) => ({
      value: inv.id.toString(),
      label: `${inv.Product?.name ?? 'Unknown'} - ${inv.size} - ${inv.sizeDescription} (${inv.type})`
    }))
  ];

  const selectedOption =
    inventoryOptions.find(opt => opt.value === inventoryId) || inventoryOptions[0];

  return (
    <ItemRow>
      <SelectWrapper>
        <Select
          options={inventoryOptions}
          value={selectedOption}
          onChange={(selected) => setInventoryId(selected?.value || '')}
          placeholder="-- Select Inventory --"
        />
      </SelectWrapper>

      <ItemInput
        type="number"
        min="1"
        value={quantity}
        onChange={(e) => setQuantity(parseInt(e.target.value) || 1)}
        placeholder="Qty"
        width="60px"
      />

      <ItemInput
        type="number"
        min="0"
        value={unitPrice}
        onChange={(e) => setUnitPrice(parseInt(e.target.value) || 0)}
        placeholder="Unit Price"
        width="100px"
      />

      <RemoveIcon>
        <IoCloseSharp onClick={onRemove} />
      </RemoveIcon>
    </ItemRow>
  );
};

export default AddOrderItem;